import React from 'react';

import { NewIconNames } from '../../../../../components/common/icon/new-icon-names';
import i18n from '../../../../../utils/i18n/i18n';
import { OperationAction } from '../../../operation-panel.types';
import { ActionButton } from '../action-button/action-button';

interface Props {
  action: OperationAction;
  onLocateClick?(): void;
  onRetryClick?(): void;
  onCancelClick?(): void;
  cancelButtonHint?: string;
}

export const HoverActionButton: React.FunctionComponent<Props> = ({
  action,
  cancelButtonHint,
  onCancelClick,
  onLocateClick,
  onRetryClick,
}: Props) => {
  switch (action) {
    case OperationAction.Retry:
      return (
        <ActionButton
          onClick={onRetryClick}
          hint={i18n.t('operation-panel.retry')}
          icon={NewIconNames.Refresh}
        />
      );

    case OperationAction.Cancel:
      return (
        <ActionButton
          onClick={onCancelClick}
          hint={cancelButtonHint}
          icon={NewIconNames.X}
        />
      );

    case OperationAction.Locate:
      return (
        <ActionButton
          onClick={onLocateClick}
          hint={i18n.t('operation-panel.locate-file')}
          icon={NewIconNames.Search}
        />
      );

    default:
      return null;
  }
};
